import { Card, Container, Grid, Stack } from "@mui/material"
import { CurrentZoneDisplay } from "./currentZoneDisplay"
import { History } from './history'
import { Timer } from "./timer"

import './tracker.css'

export const Tracker = () => {
  return <Container className='tracker-container'>
    <Stack spacing={1}>
      <Card className='tracker-card'>
        <CurrentZoneDisplay />
      </Card>
      <Card className='tracker-card' sx={{textAlign: 'center'}}>
        <Timer />
      </Card>
      <Card className='tracker-card'>
        <History />
      </Card>
    </Stack>
  </Container>
}